<template>
  <material-card>
    <v-card class="mb-6">
      <v-card-title
        >Banners <v-spacer></v-spacer
        ><UploadForm
          :uploadFieldLabel="'Select banner'"
          @file-submitted="uploadBanner"
      /></v-card-title>
      <v-divider class="mx-4"></v-divider>
      <div class="pa-4">
        <v-card class="mb-4" v-for="banner in banners" :key="banner.id">
          <div class="d-flex justify-space-between">
            <div>
              <v-card-text class="mr-auto" style="width: 100%">
                <VTextField
                  filled
                  label="Url"
                  placeholder="Insert url"
                  v-model="banner.url"
                />
              </v-card-text>
              <v-card-actions>
                <v-btn
                  @click="updateBanner(banner)"
                  class="ml-2 mt-3"
                  height="40px"
                  color="primary"
                  right
                >
                  Update <v-icon>mdi-square-edit-outline</v-icon>
                </v-btn>
                <v-btn
                  @click="deleteBanner(banner.id)"
                  class="ml-2 mt-3"
                  height="40px"
                  color="primary"
                  otlined
                  right
                >
                  Delete <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </div>
            <v-avatar class="ma-3" size="125" tile>
              <v-img :src="banner.banner" contain></v-img>
            </v-avatar>
          </div>
        </v-card>
      </div>
    </v-card>
  </material-card>
</template>
<script>
import apiService from '@/services'
import { mapState } from 'vuex'
import UploadForm from './BannerUploader'

export default {
  props: {
    canEdit: {
      type: Boolean,
      default: false
    },
    entityId: {
      type: Number,
      required: true,
      default: 0
    }
  },
  components: {
    UploadForm
  },
  computed: {
    // Get general entity statuses from store
    ...mapState('init', ['statuses', 'interventionAreas'])
  },
  mounted () {
    this.getNpoBanners(this.entityId)
  },
  data () {
    return {
      optionText: '',
      areaList: [],
      options: [],
      banners: [],
      survey: {},
      areasDialog: false,
      areasAssociationRequest: [],
      areasAssociation: {
        valid: false
      }
    }
  },
  methods: {
    getNpoBanners (npoId) {
      apiService
        .getNpoBanners(npoId)
        .then((data) => {
          this.banners = data
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error
          })
        })
    },

    uploadBanner (formData) {
      console.log('ADD BANNER', this.entityId)
      const data = [
        {
          npo: this.entityId,
          banner: formData
        }
      ]
      apiService
        .addNpoBanner(data)
        .then((response) => {
          console.log('RESPONSE', response)
          this.getNpoBanners(this.entityId)
        })
    },

    updateBanner (banner) {
      apiService
        .updateNpoBanner(banner)
        .then((response) => {
          this.getNpoBanners(this.entityId)
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error
          })
        })
    },

    deleteBanner (optionId) {
      console.log('Deleting', optionId)
      apiService
        .deleteNpoBanner(optionId)
        .then((response) => {
          this.getNpoBanners(this.entityId)
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error
          })
        })
    }
  }
}
</script>
